class YearBox extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('.year-box__header');

    this.header.addEventListener('click', this.onYearHeaderClick.bind(this));
    window.addEventListener('resize', this.adjustHeight.bind(this));
  }

  onYearHeaderClick() {
    // 1. 'active' class
    this.classList.toggle('active');

    // 2. Open
    this.adjustHeight()
  }

  adjustHeight() {
    const content = this.querySelector('.year-box__content');
    const contentContainer = this.querySelector('.year-box__content-container');

    if (this.classList.contains('active')) content.style.maxHeight = getComputedStyle(contentContainer).height;
    else content.style.maxHeight = 0;
  }
}

customElements.define('year-box', YearBox);